export const APP_NAME = "conceptor";
export const APP_VERSION = "1.2.23";
export const LANDING_PAGE_URL = "https://conceptor.ai/";
export const DEFAULT_COMPANY_LOGO = "default_company_logo.png";
export const SESSION_TIME = 5; // hours
export const IMAGE_HOST = "https://d3ethiri6v3lef.cloudfront.net/";
export const INVESTOR_LOGO_HOST = "https://img.logo.dev/";
export const LOGO_DEV_PUBLIC_KEY = 'pk_AxVc7cghQzWRtEdUsXpC5A';
export const ENTERPRISE_ROLE = "enterprise";
export const PROFESSIONAL_ROLE = "professional";


export const MAX_TEXT_INPUT_CHAR_LIMIT = 1000;
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PAGE_TITLES = [
  // More specific keys first — matching uses pathname.includes(key)
  { key: "generate-api-key", title: "Generate API Key" },
  { key: "forgot-password", title: "Forgot Password" },
  { key: "reset-password", title: "Reset Password" },
  { key: "set-password", title: "Set Password" },
  { key: "signup-success", title: "Signup Success" },
  { key: "signup-canceled", title: "Signup Cancel" },
  { key: "signup", title: "Signup" },
  { key: "onboarding", title: "Onboarding" },
  { key: "oauth/callback", title: "OAuth Callback" },
  { key: "leads-manager/create", title: "Create Lead" },
  { key: "leads-manager/edit", title: "Update Lead" },
  { key: "leads-manager", title: "Leads Manager" },
  { key: "company-submission", title: "Company Brief" },
  { key: "company-detail", title: "Company Detail" },
  { key: "company-tasks", title: "Company Tasks" },
  { key: "ai-recommendation", title: "Florence" },
  { key: "my-profile", title: "My Profile" },
  { key: "investors", title: "Investor Detail" },
  { key: "companies", title: "Companies" },
  { key: "dataset", title: "Investor Search" },
  { key: "analytics", title: "Admin Analytics" },
  { key: "subscription", title: "Subscription" },
  { key: "payment-canceled", title: "Payment Cancel" },
  { key: "payment-success", title: "Payment Success" },
  { key: "home", title: "Firm Overview" },
];

export const recordActions = {
  buyerPDF: "buyer_pdf",
  buyerCSV: "buyer_csv",
  buyerCRMExport: "buyer_crm_export",
  investorPDF: "investor_pdf",
  investorCSV: "investor_csv",
  investorCRMExport: "investor_crm_export",
  leadsPDF: "leads_pdf",
  leadsCSV: "leads_csv",
  leadsCRMExport: "leads_crm_export",
};

const answersSuggestions = [
  "Don't care",
  "Care a little",
  "Care a little",
  "Care a little",
  "Moderately Care",
  "Moderately Care",
  "Care a lot",
  "Care a lot",
  "Care a lot",
];
export const saleTwoSuggestions = [...answersSuggestions, "Upmost Priority"];
export const saleThreeSuggestions = [...answersSuggestions, "Company cannot change"];

export const BUYER_TYPES_FILTERS = [
  {
    value: "venture capital",
    label: "Venture Capital",
  },
  {
    value: "corporation",
    label: "Corporation",
  },
  {
    value: "private equity",
    label: "Private Equity",
  },
];
export const BUYER_STATES_FILTERS = [
  { label: "International", value: "International" },
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SK" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "W" },
];

export const INVESTOR_TYPES_FILTERS = [
  {
    value: "Venture Capital",
    label: "Venture Capital",
  },
  {
    value: "Corporation",
    label: "Corporation",
  },
  {
    value: "Private Equity",
    label: "Private Equity",
  },
];


export const CHART_FILTERS = [
  {
    label: "Day",
    value: "day",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "1 month",
    value: "one-month",
  },
  {
    label: "3 months",
    value: "three-month",
  },
  {
    label: "6 months",
    value: "six-month",
  },
  {
    label: "9 months",
    value: "nine-month",
  },
  {
    label: "Year",
    value: "year",
  },
];

export const DOC_TYPES = {
  "application/pdf": "PDF",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
  "application/msword": "DOC",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.ms-powerpoint": "PPT",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPTX",
  "application/vnd.oasis.opendocument.text": "TXT",
  "application/x-tex": "TXT",
  "text/plain": "TXT",
  "txt/rtf": "TXT",
  "txt/vnd.ms-works": "TXT",
  "txt/vnd.lotus-1-2-3": "TXT",
  "txt/vnd.wordperfect": "TXT",
};

export const ventureTypeFields = [
  "naics_six_digit_industry",
  "broad_specialty",
  "narrow_specialty",
];

export const privateEquityTypeFields = [
  "preferred_ebitda",
  "preferred_revenue",
  "preferred_ev",
  "typical_equity_investments",
];

export const primarySectorOptions = [
  { label: "Communication Services", value: "Communication Services" },
  { label: "Consumer Discretionary", value: "Consumer Discretionary" },
  { label: "Consumer Staples", value: "Consumer Staples" },
  { label: "Energy", value: "Energy" },
  { label: "Financials", value: "Financials" },
  { label: "Government/Public Sector", value: "Government/Public Sector" },
  { label: "Healthcare", value: "Healthcare" },
  { label: "Industrials", value: "Industrials" },
  { label: "Materials", value: "Materials" },
  { label: "Real Estate", value: "Real Estate" },
  { label: "Technology", value: "Technology" },
  { label: "Utilities", value: "Utilities" },
];
